import React from 'react';
import withNuiIntl from '../utils/withNuiIntl';
import compose from '../utils/compose';
import withStylesLoaded from '../utils/withStylesLoaded';
import Error, { ERRORS } from './_Error';

export { ERRORS };

// this wrapper component is necessary to wrap the component
// in a ThemeProvider (handled in withStylesLoaded)
const AppError = (props) => <Error {...props} />;

AppError.displayName = 'AppError';

AppError.propTypes = {
    ...Error.propTypes,
};

export default compose(
    withStylesLoaded,
    withNuiIntl,
)(AppError);
